import React from 'react';
import accounting from 'accounting';
import { Table } from 'arag-ui-lib';
import { CURRENCY } from '../../helpers/variables';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const overviewColumns = [
    { propertyName: 'rowLabel', header: CONTENT_STRINGS.ADVANCE_DISBURSEMENTS },
    { propertyName: 'applied', header: CONTENT_STRINGS.APPLIED },
    { propertyName: 'rejected', header: CONTENT_STRINGS.REJECTED },
    { propertyName: 'approved', header: CONTENT_STRINGS.APPROVED },
    { propertyName: 'processing', header: CONTENT_STRINGS.PROCESSING },
    { propertyName: 'paid', header: CONTENT_STRINGS.PAID },
    { propertyName: 'partSettled', header: CONTENT_STRINGS.PART_SETTLED },
    { propertyName: 'settled', header: CONTENT_STRINGS.SETTLED },
    { propertyName: 'total', header: CONTENT_STRINGS.TOTAL },
];

const noop = () => {};

const AdvanceDisbursementsOverviewTable = (props) => {
    const {
        totalValueOfAdvancedDisbursements,
        totalValueOfApplied,
        totalValueOfApproved,
        totalSettledValue,
        totalRejectedValue,
        totalProcessingValue,
        totalPaidValue,
        totalPartSettledValue,
        totalNumberOfAdvancedDisbursements,
        totalNumberOfApplied,
        totalNumberOfApproved,
        totalSettledRecords,
        totalRejectedRecords,
        totalProcessingRecords,
        totalPaidRecords,
        totalPartSettledRecords,
        isAragUser,
    } = props;

    const countRow = {
        rowLabel: <strong>{CONTENT_STRINGS.NUMBER_OF_ADVANCE_DISBURSEMENTS_PER_STATUS}</strong>,
        applied: totalNumberOfApplied,
        rejected: totalRejectedRecords,
        approved: totalNumberOfApproved,
        processing: totalProcessingRecords,
        paid: totalPaidRecords,
        partSettled: totalPartSettledRecords,
        settled: totalSettledRecords,
        total: totalNumberOfAdvancedDisbursements,
    };

    const amountRow = {
        rowLabel: <strong>{CONTENT_STRINGS.TOTAL_AMOUNT_OF_ADVANCE_DISBURSEMENTS_PER_STATUS}</strong>,
        applied: accounting.formatMoney(totalValueOfApplied, CURRENCY, 2),
        rejected: accounting.formatMoney(totalRejectedValue, CURRENCY, 2),
        approved: accounting.formatMoney(totalValueOfApproved, CURRENCY, 2),
        processing: accounting.formatMoney(totalProcessingValue, CURRENCY, 2),
        paid: accounting.formatMoney(totalPaidValue, CURRENCY, 2),
        partSettled: accounting.formatMoney(totalPartSettledValue, CURRENCY, 2),
        settled: accounting.formatMoney(totalSettledValue, CURRENCY, 2),
        total: accounting.formatMoney(totalValueOfAdvancedDisbursements, CURRENCY, 2),
    };

    const tableData = isAragUser ? [countRow, amountRow] : [amountRow];

    return (
        <Table
            columns={overviewColumns}
            data={tableData}
            pageSize={tableData.length}
            totalRecords={tableData.length}
            goAtPrevious={noop}
            goAtNext={noop}
            goAtStart={noop}
            goAtEnd={noop}
            goAtPage={noop}
            onPageSizeChange={noop}
            pageSizeOptions={[]}
            responsive
            striped
            noResultsMessage={CONTENT_STRINGS.NO_RESULTS_FOUND}
            tableWrapperTestId={'advance-disbursements-summary-table'}
        />
    );
};

export default AdvanceDisbursementsOverviewTable;
